<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Gerenciar</h1>
        <paragrafo>
          <negrito>Produtos/Gerenciar:</negrito>
          Ambiente para adicionar novos produtos ou para editar produtos já
          cadastrados.
          <ul>
            <paragrafo><li>Primeiramente selecionar a loja;</li></paragrafo>
            <li>
              Selecionar a opção “Novo Produto” para criar um novo produto;
            </li>
          </ul>
        </paragrafo>
        <imagem :src="image_1" />
        <paragrafo>
          O primeiro ícone refere-se às variações (ícone de livro) onde será
          aberto um pop-up mostrando a configuração de variações do produto sem
          precisar editá-lo para visualizar. Os demais ícones correspondem aos
          comandos de: Editar, Acessar e Deletar.
        </paragrafo>
        <paragrafo
          >Segundo ícone refere-se a funcionalidade de duplicação de produtos,
          facilitando a parametrização.
        </paragrafo>
        <imagem :src="image_11" />
        <paragrafo
          >Preencher todos os campos obrigatórios (sinalizados com o asterisco
          vermelho), exemplo:</paragrafo
        >
        <paragrafo
          ><negrito>Traduções:</negrito> Atente-se ao botão que possibilita
          adicionar traduções em inglês e espanhol, evidenciado pelo ícone de
          bandeira. Ele estará presente nos campos: Evento e Descrição do
          evento.</paragrafo
        >
        <imagem :src="image_2" />
        <paragrafo>
          A opção de <negrito>Canal de Venda</negrito> permite configurar onde
          este produto deve ser vendido: Somente Web, somente POS ou Web e Pos.
        </paragrafo>
        <paragrafo>Observação sobre os campos marcados em vermelho:</paragrafo>
        <paragrafo><negrito>Tipo:</negrito></paragrafo>
        <ul>
          <li>
            Ingresso: produto destinado à venda ao acesso em eventos ou atrações
          </li>
        </ul>
        <paragrafo><negrito>Voucher:</negrito></paragrafo>
        <ul>
          <li>
            Destinado para troca por um produto ou promoção, como por exemplo
            camisetas, pulseiras, descontos, consumos, etc.
          </li>
        </ul>
        <paragrafo><negrito>Iframe (Marketplace):</negrito></paragrafo>
        <ul>
          <li>
            Usado para incorporar o conteúdo de uma página em outra, ou seja,
            pode ser utilizada uma página externa para venda atráves do
            Eleven360 Marketplace.
          </li>
        </ul>
        <paragrafo><negrito>Categoria:</negrito></paragrafo>
        <ul>
          <li>
            Selecionar em qual categoria este produto se encaixa. Aparecerá no
            site conforme imagem. Se adicionar todos os produtos na mesma
            categoria, aparecerá um único ícone, conforme abaixo, ou seja, todos
            os produtos foram adicionados à categoria Parques.
          </li>
        </ul>
        <imagem :src="image_3" />
        <ul>
          <li>Categoria: Parques</li>
          <li>Tipo: Voucher/Ingresso</li>
          <li>
            O campo <negrito>Tag</negrito>, pode ser utilizado para evidenciar
            uma Promoção, Desconto ou Novidade específica de algum produto. O
            produto aparecerá com uma faixa em destaque conforme abaixo:
          </li>
        </ul>
        <v-row justify="center" class="mt-5">
          <img :src="image_4" />
        </v-row>
        <h1 class="mt-5">Regras de acesso e Período de vendas</h1>
        <paragrafo>
          <negrito>Regras de acesso</negrito> e
          <negrito>Período de vendas</negrito> dependem exclusivamente da forma
          de uso do produto determinada pela loja.</paragrafo
        >
        <imagem :src="image_5" />
        <paragrafo>
          <ul>
            <li>
              Selecionar tipo de imagem, após isso clicar no campo “Clique aqui
              para importar a imagem”. Feito isso, selecione:
              <negrito>“FAZER UPLOAD”</negrito>
            </li>
          </ul>
        </paragrafo>
        <paragrafo
          >Abaixo a forma que as imagens aparecerão no site de
          vendas:</paragrafo
        >
        <imagem :src="image_6" />
        <paragrafo
          >A opção marcada em verde corresponde à possibilidade de criar
          campanhas de venda, ou seja, selecionar datas e valores especiais,
          descontos, etc.</paragrafo
        ><paragrafo
          ><negrito>Por exemplo</negrito>: Poderá haver um produto que esteja
          disponível apenas em uma única data e único valor. Outros terão várias
          datas e valores (Inteira R$20,00 (31/12/2023), Meia R$10,00
          (31/12/2023), Estudante R$5,00 (31/12/2023), etc).</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Gerenciar",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Produtos/produto1.png",
      image_11: "/imagensAdmin/Produtos/produto1.1.png",
      image_2: "/imagensAdmin/Produtos/produto2.png",
      image_3: "/imagensAdmin/Produtos/produto3.png",
      image_4: "/imagensAdmin/Produtos/produto4.png",
      image_5: "/imagensAdmin/Produtos/produto5.png",
      image_6: "/imagensAdmin/Produtos/produto6.png",
    };
  },
};
</script>
